import { Link } from "react-router-dom";
import { useChristmasTheme } from "@/hooks/useChristmasTheme";

// Logotipo oficial de VendeYa (con fondo transparente).
export const VENDEYA_LOGO_URL =
  "https://storage.helloreaddy.io/project_files/360884e8-4dc5-4075-b4f7-2a213dd9c223/9564d42f-8878-43e9-8fac-192ee5ca0d8e_compressed_1.webp";

interface BrandLogoProps {
  showDot?: boolean;
  size?: "sm" | "lg";
}

/**
 * Bloque de marca reutilizable: isotipo oficial de VendeYa + nombre,
 * con un punto indicador opcional (efecto de pulso) en la esquina del isotipo.
 * Durante la campaña navideña muestra un pequeño detalle festivo junto al logo.
 */
export default function BrandLogo({ showDot = false, size = "sm" }: BrandLogoProps) {
  const { enabled, animations } = useChristmasTheme();
  const isLarge = size === "lg";

  return (
    <Link
      to="/"
      className={`flex items-center whitespace-nowrap ${isLarge ? "gap-3" : "gap-2"}`}
    >
      <span
        className={`relative flex shrink-0 items-center justify-center ${
          isLarge ? "h-9 w-14" : "h-7 w-11"
        }`}
      >
        <img
          src={VENDEYA_LOGO_URL}
          alt="VendeYa"
          className="h-full w-full object-contain"
        />
        {showDot && (
          <span className="absolute right-2 top-1 flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary-400 opacity-75"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-secondary-500 ring-2 ring-background-50"></span>
          </span>
        )}
      </span>
      <span
        className={`font-heading font-bold text-foreground-950 ${
          isLarge ? "text-xl" : "text-base"
        }`}
      >
        Vende<span className="text-primary-500">Ya</span>
      </span>
      {enabled && (
        <span
          aria-hidden="true"
          className={`text-sm leading-none ${animations ? "xmas-float" : ""}`}
        >
          🎄
        </span>
      )}
    </Link>
  );
}